import { useEffect } from "react";
import { useSocket } from "src/socket/useSocket";

export const useChatRoomSocket = (discussionId?: string) => {
  const socket = useSocket();

  useEffect(() => {
    if (!socket || !discussionId) return;

    socket.emit("active_chatroom", discussionId);

    return () => {
      socket.emit("inactive_chatroom", discussionId);
    };
  }, [socket, discussionId]);
};
